// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";

// import fullTruck from "../assets/images/services/full-truck.jpg";
// import partLoad from "../assets/images/services/part-load.jpg";
// import express from "../assets/images/services/express.jpg";
// import secure from "../assets/images/services/secure.jpg";

// const services = [
//   {
//     title: "Full Truck Load",
//     desc: `Our Full Truck Load (FTL) service is designed for businesses that require
// dedicated transportation for high-volume shipments. With exclusive vehicle
// allocation, optimized routing, and strict delivery timelines, we ensure your
// cargo moves directly from origin to destination without unnecessary stops.

// This service is ideal for manufacturers, distributors, and enterprises that
// demand speed, security, and operational control.`,
//     image: fullTruck,
//     accent: "#2563eb", // blue
//   },
//   {
//     title: "Part Load Services",
//     desc: `Our Part Load services provide a cost-efficient solution for smaller shipments
// by intelligently consolidating cargo moving in the same direction. This allows
// businesses to optimize costs while maintaining reliability and delivery
// consistency.

// Every shipment is handled with equal care, visibility, and accountability.`,
//     image: partLoad,
//     accent: "#16a34a", // green (logo harmony)
//   },
//   {
//     title: "Express Delivery",
//     desc: `When time is critical, our Express Delivery service ensures priority handling
// and accelerated transit times. Backed by real-time tracking and proactive
// coordination, we help businesses meet urgent deadlines without compromise.

// Trusted by industries where speed directly impacts revenue and reputation.`,
//     image: express,
//     accent: "#2563eb",
//   },
//   {
//     title: "Secure Transportation",
//     desc: `Security is at the core of our transportation operations. Our Secure
// Transportation service integrates GPS-enabled vehicles, route monitoring,
// trained personnel, and insurance-backed cargo protection.

// From high-value goods to sensitive consignments, we provide complete peace
// of mind through disciplined processes and advanced safety protocols.`,
//     image: secure,
//     accent: "#16a34a",
//   },
// ];

// const ServiceRow = ({ service, reverse }) => {
//   const ref = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: ["start end", "center center"],
//   });

//   const scale = useTransform(scrollYProgress, [0, 1], [0.93, 1.06]);
//   const opacity = useTransform(scrollYProgress, [0, 0.4], [0, 1]);
//   const x = useTransform(
//     scrollYProgress,
//     [0, 1],
//     reverse ? [110, 0] : [-110, 0]
//   );

//   return (
//     <motion.div
//       ref={ref}
//       style={{
//         display: "flex",
//         flexDirection: reverse ? "row-reverse" : "row",
//         alignItems: "center",
//         gap: "80px",
//         marginBottom: "150px",
//       }}
//     >
//       {/* IMAGE */}
//       <motion.div
//         whileHover={{ scale: 1.07 }}
//         transition={{ duration: 0.45, ease: "easeOut" }}
//         style={{
//           flex: 1,
//           height: "320px",
//           scale,
//           borderRadius: "26px",
//           backgroundImage: `
//             linear-gradient(
//               rgba(8,23,40,0.35),
//               rgba(8,23,40,0.35)
//             ),
//             url(${service.image})
//           `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           boxShadow: "0 50px 100px rgba(8,23,40,0.35)",
//         }}
//       />

//       {/* TEXT */}
//       <motion.div
//         style={{
//           flex: 1,
//           opacity,
//           x,
//           paddingLeft: "28px",
//           borderLeft: `5px solid ${service.accent}`,
//         }}
//       >
//         <h3
//           style={{
//             fontSize: "34px",
//             marginBottom: "20px",
//             color: "#0b1f2a",
//           }}
//         >
//           {service.title}
//         </h3>

//         <p
//           style={{
//             fontSize: "16px",
//             lineHeight: "1.85",
//             color: "#334155",
//             whiteSpace: "pre-line",
//           }}
//         >
//           {service.desc}
//         </p>
//       </motion.div>
//     </motion.div>
//   );
// };

// const Services = () => {
//   return (
//     <section
//       id="services"
//       style={{
//         padding: "170px 40px",
//         background: `
//           linear-gradient(
//             180deg,
//             #f8fbff 0%,
//             #eef4ff 35%,
//             #eafaf1 70%,
//             #f8fbff 100%
//           )
//         `,
//       }}
//     >
//       {/* HEADING */}
//       <div style={{ textAlign: "center", marginBottom: "150px" }}>
//         <h2
//           style={{
//             fontSize: "48px",
//             marginBottom: "16px",
//             color: "#0b1f2a",
//           }}
//         >
//           Our Services
//         </h2>

//         <p
//           style={{
//             color: "#475569",
//             maxWidth: "780px",
//             margin: "0 auto",
//             fontSize: "16px",
//             lineHeight: "1.7",
//           }}
//         >
//           Enterprise-grade transportation solutions designed to support
//           businesses with scale, reliability, and operational excellence —
//           across India and beyond.
//         </p>
//       </div>

//       {/* SERVICES LIST */}
//       <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//         {services.map((service, index) => (
//           <ServiceRow
//             key={index}
//             service={service}
//             reverse={index % 2 !== 0}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// export default Services;


// Above code is for the scroll of service section with images and text description and the below one is working one 

// import {
//   motion,
//   useScroll,
//   useTransform,
//   useMotionValueEvent,
// } from "framer-motion";
// import { useRef, useState } from "react";

// import fullTruck from "../assets/images/services/full-truck.jpg";
// import partLoad from "../assets/images/services/part-load.jpg";
// import express from "../assets/images/services/express.jpg";
// import secure from "../assets/images/services/secure.jpg";

// const services = [
//   {
//     title: "Full Truck Load",
//     desc: `Our Full Truck Load (FTL) service is designed for businesses that require
// dedicated transportation for high-volume shipments. With exclusive vehicle
// allocation, optimized routing, and strict delivery timelines, we ensure your
// cargo moves directly from origin to destination without unnecessary stops.

// This service is ideal for manufacturers, distributors, and enterprises that
// demand speed, security, and operational control.`,
//     image: fullTruck,
//   },
//   {
//     title: "Part Load Services",
//     desc: `Our Part Load services provide a cost-efficient solution for smaller shipments
// by intelligently consolidating cargo moving in the same direction. This allows
// businesses to optimize costs while maintaining reliability and delivery
// consistency.

// Every shipment is handled with equal care, visibility, and accountability.`,
//     image: partLoad,
//   },
//   {
//     title: "Express Delivery",
//     desc: `When time is critical, our Express Delivery service ensures priority handling
// and accelerated transit times. Backed by real-time tracking and proactive
// coordination, we help businesses meet urgent deadlines without compromise.

// Trusted by industries where speed directly impacts revenue and reputation.`,
//     image: express,
//   },
//   {
//     title: "Secure Transportation",
//     desc: `Security is at the core of our transportation operations. Our Secure
// Transportation service integrates GPS-enabled vehicles, route monitoring,
// trained personnel, and insurance-backed cargo protection.

// From high-value goods to sensitive consignments, we provide complete peace
// of mind through disciplined processes and advanced safety protocols.`,
//     image: secure,
//   },
// ];

// const ServiceScene = ({
//   service,
//   index,
//   scrollYProgress,
//   isInteractive,
//   activeIndex,
//   setActiveIndex,
//   isMobile,
// }) => {
//   const start = index * 0.2;
//   const mid = start + 0.08;
//   const end = start + 0.16;
//   const final = 0.85;

//   const scale = useTransform(
//     scrollYProgress,
//     [start, mid, end, final],
//     [0.72, 1, 0.88, activeIndex === index ? 0.96 : 0.88]
//   );

//   const x = useTransform(
//     scrollYProgress,
//     [start, end, final],
//     ["0%", `${-240 + index * 200}px`, `${-360 + index * 260}px`]
//   );

//   const opacity = useTransform(scrollYProgress, [start, mid], [0, 1]);

//   return (
//     <motion.div
//       onClick={() => isInteractive && setActiveIndex(index)}
//       style={{
//         position: isMobile ? "relative" : "absolute",

//         /* 🔒 MOBILE FREEZE */
//         scale: isMobile ? 1 : scale,
//         x: isMobile ? "0%" : x,
//         opacity: isMobile ? 1 : opacity,

//         cursor: isInteractive ? "pointer" : "default",
//         pointerEvents: isInteractive ? "auto" : "none",
//         marginBottom: isMobile ? "48px" : 0,
//       }}
//     >
//       <motion.div
//         animate={{
//           scale:
//             !isMobile && isInteractive && activeIndex === index ? 1.03 : 1,
//         }}
//         transition={{ duration: 0.3, ease: "easeOut" }}
//         style={{
//           width: isMobile ? "92vw" : "480px",
//           maxWidth: "480px",
//           borderRadius: "26px",
//           background: "rgba(255,255,255,0.94)",
//           boxShadow: "0 30px 70px rgba(0,0,0,0.25)",
//           overflow: "hidden",
//         }}
//       >
//         {/* BLUE ACCENT */}
//         <div
//           style={{
//             height: "3px",
//             background:
//               "linear-gradient(90deg, rgba(37,99,235,0.9), rgba(37,99,235,0.3))",
//           }}
//         />

//         {/* IMAGE */}
//         <div
//           style={{
//             height: isMobile ? "220px" : "280px",
//             backgroundImage: `url(${service.image})`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         />

//         {/* TEXT */}
//         <div style={{ padding: "26px 28px" }}>
//           <h3
//             style={{
//               fontSize: "26px",
//               marginBottom: "16px",
//               color: "#0b1f2a",
//             }}
//           >
//             {service.title}
//           </h3>

//           <p
//             style={{
//               fontSize: "15px",
//               lineHeight: "1.85",
//               color: "#334155",
//               whiteSpace: "pre-line",
//             }}
//           >
//             {service.desc}
//           </p>
//         </div>
//       </motion.div>
//     </motion.div>
//   );
// };

// const Services = () => {
//   const ref = useRef(null);
//   const isMobile = window.innerWidth < 768;

//   const [activeIndex, setActiveIndex] = useState(0);
//   const [isInteractive, setIsInteractive] = useState(false);

//   const { scrollYProgress } = useScroll({
//     target: ref,
//     offset: ["start start", "end end"],
//   });

//   useMotionValueEvent(scrollYProgress, "change", (v) => {
//     if (v > 0.85 && !isInteractive) setIsInteractive(true);
//     if (v <= 0.85 && isInteractive) setIsInteractive(false);
//   });

//   const bg = useTransform(
//     scrollYProgress,
//     [0.65, 0.9],
//     ["#f8fbff", "#1e3a8a"]
//   );

//   const headingOpacity = useTransform(scrollYProgress, [0, 0.15], [1, 0]);
//   const headingY = useTransform(scrollYProgress, [0, 0.15], [0, -40]);

//   return (
//     <motion.section
//       id="services"
//       ref={ref}
//       style={{
//         height: isMobile ? "auto" : "560vh",
//         background: bg,
//         paddingBottom: isMobile ? "120px" : "0px",
//       }}
//     >
//       {/* HEADING */}
//       <motion.div
//         style={{
//           position: isMobile ? "relative" : "sticky",
//           top: isMobile ? "auto" : "110px",
//           zIndex: 6,
//           textAlign: "center",
//           marginBottom: "40px",
//           opacity: headingOpacity,
//           y: headingY,
//           pointerEvents: "none",
//         }}
//       >
//         <h2
//           style={{
//             fontSize: "56px",
//             fontWeight: 700,
//             color: "#0b1f2a",
//             marginBottom: "12px",
//           }}
//         >
//           Our Services
//         </h2>
//         <p
//           style={{
//             fontSize: "18px",
//             color: "#475569",
//             maxWidth: "720px",
//             margin: "0 auto",
//             lineHeight: "1.7",
//           }}
//         >
//           Logistics capabilities engineered for enterprise-scale operations.
//         </p>
//       </motion.div>

//       {/* SCENE */}
//       <div
//         style={{
//           position: isMobile ? "relative" : "sticky",
//           top: isMobile ? "auto" : 0,
//           height: isMobile ? "auto" : "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexDirection: isMobile ? "column" : "row",
//           gap: isMobile ? "48px" : "0px",
//           paddingTop: isMobile ? "40px" : 0,
//         }}
//       >
//         {services.map((service, index) => (
//           <ServiceScene
//             key={index}
//             service={service}
//             index={index}
//             scrollYProgress={scrollYProgress}
//             isInteractive={isInteractive}
//             activeIndex={activeIndex}
//             setActiveIndex={setActiveIndex}
//             isMobile={isMobile}
//           />
//         ))}
//       </div>
//     </motion.section>
//   );
// };

// export default Services;

import {
  motion,
  useScroll,
  useTransform,
  useMotionValueEvent,
} from "framer-motion";
import { useRef, useState } from "react";

import fullTruck from "../assets/images/services/full-truck.jpg";
import partLoad from "../assets/images/services/part-load.jpg";
import express from "../assets/images/services/express.jpg";
import secure from "../assets/images/services/secure.jpg";

const services = [
  {
    title: "Full Truck Load",
    tag: "FTL",
    accent: "#2563eb",
    desc: `Our Full Truck Load (FTL) service is designed for businesses that require
dedicated transportation for high-volume shipments. With exclusive vehicle
allocation, optimized routing, and strict delivery timelines, we ensure your
cargo moves directly from origin to destination without unnecessary stops.

This service is ideal for manufacturers, distributors, and enterprises that
demand speed, security, and operational control.`,
    image: fullTruck,
  },
  {
    title: "Part Load Services",
    tag: "PTL",
    accent: "#16a34a",
    desc: `Our Part Load services provide a cost-efficient solution for smaller shipments
by intelligently consolidating cargo moving in the same direction. This allows
businesses to optimize costs while maintaining reliability and delivery
consistency.

Every shipment is handled with equal care, visibility, and accountability.`,
    image: partLoad,
  },
  {
    title: "Express Delivery",
    tag: "XPD",
    accent: "#2563eb",
    desc: `When time is critical, our Express Delivery service ensures priority handling
and accelerated transit times. Backed by real-time tracking and proactive
coordination, we help businesses meet urgent deadlines without compromise.

Trusted by industries where speed directly impacts revenue and reputation.`,
    image: express,
  },
  {
    title: "Secure Transportation",
    tag: "SEC",
    accent: "#16a34a",
    desc: `Security is at the core of our transportation operations. Our Secure
Transportation service integrates GPS-enabled vehicles, route monitoring,
trained personnel, and insurance-backed cargo protection.

From high-value goods to sensitive consignments, we provide complete peace
of mind through disciplined processes and advanced safety protocols.`,
    image: secure,
  },
];

const ServiceScene = ({
  service,
  index,
  scrollYProgress,
  isInteractive,
  activeIndex,
  setActiveIndex,
  isMobile,
}) => {
  const start = index * 0.2;
  const mid = start + 0.08;
  const end = start + 0.16;
  const final = 0.85;
  const isActive = activeIndex === index;

  const scale = useTransform(
    scrollYProgress,
    [start, mid, end, final],
    [0.72, 1, 0.88, isActive ? 0.97 : 0.86]
  );

  const x = useTransform(
    scrollYProgress,
    [start, end, final],
    ["0%", `${-240 + index * 200}px`, `${-360 + index * 260}px`]
  );

  const rotate = useTransform(
    scrollYProgress,
    [start, end, final],
    [index % 2 === 0 ? -6 : 6, 0, isActive ? 0 : index % 2 === 0 ? -2 : 2]
  );

  const opacity = useTransform(scrollYProgress, [start, mid], [0, 1]);

  return (
    <motion.div
      onClick={() => isInteractive && setActiveIndex(index)}
      style={{
        position: isMobile ? "relative" : "absolute",
        zIndex: isActive ? 5 : 1,

        /* 🔒 MOBILE FREEZE */
        scale: isMobile ? 1 : scale,
        x: isMobile ? "0%" : x,
        rotate: isMobile ? 0 : rotate,
        opacity: isMobile ? 1 : opacity,

        cursor: isInteractive ? "pointer" : "default",
        pointerEvents: isInteractive ? "auto" : "none",
        marginBottom: isMobile ? "48px" : 0,
      }}
      initial={isMobile ? { opacity: 0, y: 60 } : false}
      whileInView={isMobile ? { opacity: 1, y: 0 } : {}}
      viewport={isMobile ? { once: true, margin: "-80px" } : undefined}
      transition={isMobile ? { duration: 0.6, ease: "easeOut" } : undefined}
    >
      <motion.div
        animate={{
          scale: !isMobile && isInteractive && isActive ? 1.04 : 1,
          boxShadow:
            !isMobile && isInteractive && isActive
              ? `0 40px 90px rgba(0,0,0,0.3), 0 0 0 3px ${service.accent}55`
              : "0 30px 70px rgba(0,0,0,0.22), 0 0 0 0px transparent",
        }}
        whileHover={isMobile ? {} : { y: -6 }}
        transition={{ duration: 0.35, ease: "easeOut" }}
        style={{
          position: "relative",
          width: isMobile ? "92vw" : "480px",
          maxWidth: "480px",
          borderRadius: "26px",
          background: "rgba(255,255,255,0.96)",
          overflow: "hidden",
        }}
      >
        {/* TOP ACCENT */}
        <div
          style={{
            height: "4px",
            background: `linear-gradient(90deg, ${service.accent}, ${service.accent}33)`,
          }}
        />

        {/* IMAGE */}
        <div
          style={{
            position: "relative",
            height: isMobile ? "220px" : "280px",
            backgroundImage: `linear-gradient(180deg, rgba(8,23,40,0) 50%, rgba(8,23,40,0.55) 100%), url(${service.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* NUMBER BADGE */}
          <div
            style={{
              position: "absolute",
              top: "16px",
              left: "16px",
              padding: "5px 12px",
              borderRadius: "999px",
              background: "rgba(8,23,40,0.55)",
              backdropFilter: "blur(6px)",
              color: "#fff",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.12em",
            }}
          >
            {String(index + 1).padStart(2, "0")} · {service.tag}
          </div>
        </div>

        {/* TEXT */}
        <div style={{ padding: "26px 28px" }}>
          <h3
            style={{
              fontSize: "26px",
              marginBottom: "16px",
              color: "#0b1f2a",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                background: service.accent,
                display: "inline-block",
                flexShrink: 0,
              }}
            />
            {service.title}
          </h3>

          <p
            style={{
              fontSize: "15px",
              lineHeight: "1.85",
              color: "#334155",
              whiteSpace: "pre-line",
            }}
          >
            {service.desc}
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

const Services = () => {
  const ref = useRef(null);
  const isMobile = window.innerWidth < 768;

  const [activeIndex, setActiveIndex] = useState(0);
  const [isInteractive, setIsInteractive] = useState(false);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    if (v > 0.85 && !isInteractive) setIsInteractive(true);
    if (v <= 0.85 && isInteractive) setIsInteractive(false);

    // Auto-advance the "active" card as you scroll through, for a livelier feel
    const stepIndex = Math.min(3, Math.floor(v / 0.2));
    if (v <= 0.85 && stepIndex !== activeIndex) setActiveIndex(stepIndex);
  });

  const bg = useTransform(
    scrollYProgress,
    [0.65, 0.9],
    ["#f8fbff", "#1e3a8a"]
  );

  const headingOpacity = useTransform(scrollYProgress, [0, 0.15], [1, 0]);
  const headingY = useTransform(scrollYProgress, [0, 0.15], [0, -40]);

  // Signature element: a "route line" that draws itself across the scene,
  // echoing the truck's path through each service stop.
  const routePathLength = useTransform(scrollYProgress, [0, 0.85], [0, 1]);
  const routeOpacity = useTransform(
    scrollYProgress,
    [0, 0.05, 0.8, 0.85],
    [0, 1, 1, 0]
  );

  return (
    <motion.section
      id="services"
      ref={ref}
      style={{
        height: isMobile ? "auto" : "560vh",
        background: bg,
        paddingBottom: isMobile ? "120px" : "0px",
        position: "relative",
      }}
    >
      {/* HEADING */}
      <motion.div
        style={{
          position: isMobile ? "relative" : "sticky",
          top: isMobile ? "auto" : "110px",
          zIndex: 6,
          textAlign: "center",
          marginBottom: "40px",
          opacity: headingOpacity,
          y: headingY,
          pointerEvents: "none",
        }}
      >
        <h2
          style={{
            fontSize: isMobile ? "38px" : "56px",
            fontWeight: 700,
            color: "#0b1f2a",
            marginBottom: "12px",
          }}
        >
          Our Services
        </h2>
        <p
          style={{
            fontSize: isMobile ? "15px" : "18px",
            color: "#475569",
            maxWidth: "720px",
            margin: "0 auto",
            lineHeight: "1.7",
            padding: isMobile ? "0 24px" : 0,
          }}
        >
          Logistics capabilities engineered for enterprise-scale operations.
        </p>
      </motion.div>

      {/* SCENE */}
      <div
        style={{
          position: isMobile ? "relative" : "sticky",
          top: isMobile ? "auto" : 0,
          height: isMobile ? "auto" : "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "48px" : "0px",
          paddingTop: isMobile ? "40px" : 0,
          overflow: "hidden",
        }}
      >
        {/* ROUTE LINE — signature element, desktop only */}
        {!isMobile && (
          <svg
            viewBox="0 0 1200 400"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              opacity: routeOpacity,
              pointerEvents: "none",
              zIndex: 0,
            }}
          >
            <motion.path
              d="M 60 320 C 280 320, 320 120, 480 200 S 700 340, 860 180 S 1040 100, 1150 160"
              stroke="#16a34a"
              strokeWidth="2"
              strokeDasharray="2 10"
              strokeLinecap="round"
              fill="none"
              style={{ pathLength: routePathLength }}
            />
          </svg>
        )}

        {services.map((service, index) => (
          <ServiceScene
            key={index}
            service={service}
            index={index}
            scrollYProgress={scrollYProgress}
            isInteractive={isInteractive}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            isMobile={isMobile}
          />
        ))}

        {/* PROGRESS DOTS — desktop only */}
        {!isMobile && (
          <div
            style={{
              position: "absolute",
              bottom: "36px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "10px",
              zIndex: 6,
            }}
          >
            {services.map((s, i) => (
              <motion.div
                key={i}
                onClick={() => isInteractive && setActiveIndex(i)}
                animate={{
                  width: activeIndex === i ? "26px" : "8px",
                  background:
                    activeIndex === i ? s.accent : "rgba(11,31,42,0.25)",
                }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                style={{
                  height: "8px",
                  borderRadius: "999px",
                  cursor: isInteractive ? "pointer" : "default",
                }}
              />
            ))}
          </div>
        )}
      </div>
    </motion.section>
  );
};

export default Services;